import styled from "@emotion/styled";
import { Alert, Container, Modal } from "react-bootstrap";
import { IStyledComponentProps } from "../../theme/theme.types";

const AlertList = styled.ul<IStyledComponentProps>`
  &.alert-list {
    list-style: none;
    margin: 0 25%;
    padding: 0;
    position: absolute;
    top: 165px;
    width: 50%;
    z-index: 200;

    .generic-alert {
      margin-bottom: 0.5rem;
    }

    @media (max-width: ${(props) =>
        props.theme.utils.getThemeBreakpoint("tablet")}) {
      top: 136px;
      left: 0;
      width: 86%;
      margin: 0 2%;
    }
  }
`;

const GenericAlert = styled(Alert)<IStyledComponentProps>`
  &.generic-alert {
    border-radius: 0;
    border: 1px solid
      ${(props) =>
        props.variant === "primary"
          ? props.theme.colors?.alerts.octonary
          : props.theme.colors?.alerts.primary};
    color: ${(props) =>
      props.variant === "primary"
        ? props.theme.colors?.alerts.octonary
        : props.theme.colors?.alerts.primary};

    button.close {
      &:hover {
        color: ${(props) =>
          props.variant === "primary"
            ? props.theme.colors?.alerts.octonary
            : props.theme.colors?.alerts.primary};
      }
    }
  }
`;

const AlertContentContainer = styled(Container)<IStyledComponentProps>`
  &.generic-alert-container {
    padding: 0;
    .generic-alert-column {
      padding-left: 12px;
      &.icon-container {
        text-align: right;
        padding-right: 12px;
      }
    }
  }
`;

export default { GenericAlert, AlertList, AlertContentContainer };
